import http from '@/http';
import createCrudModule from 'vuex-crud';
import { withDataFilter } from '@/store/index';

const store = createCrudModule({
  client: http,
  resource: 'sites',
  urlRoot: 'sites'
});

export default withDataFilter(store);
